import React from 'react';
import { SurfaceNodeType, SurfaceNodeUnion } from 'graphql/types';
import NoteNode from 'components/canvas/components/nodes/components/note-node';
import ProtocolNode from 'components/canvas/components/nodes/components/protocol-node';
import DocumentNode from 'components/canvas/components/nodes/components/document-node';
import TextNode from 'components/canvas/components/nodes/components/text-node';
import ImageNode from 'components/canvas/components/nodes/components/image-node';
import SurfaceNode from 'components/canvas/components/nodes/components/surface-node';
import QuestionnaireNode from 'components/canvas/components/nodes/components/questionnaire-node';
import DocumentSnippetNode from 'components/canvas/components/nodes/components/document-snippet-node';
import TextSnippetNode from 'components/canvas/components/nodes/components/text-snippet-node';
import { defaultNodeDimensions } from 'components/canvas/components/nodes';
import { useNodeLinkingOperations } from 'state/canvas/node-linking';
import BackgroundNode from 'components/canvas/components/nodes/components/background-node';
import { NodeProps } from 'components/canvas/components/nodes/components/base-node';

export default function useNodeComponent(): React.ComponentType<any> {
  const { deleteLink } = useNodeLinkingOperations();

  const getNodeComponent = React.useCallback((node: SurfaceNodeUnion) => {
    switch (node?.type) {
      case SurfaceNodeType.Note:
        return NoteNode;
      case SurfaceNodeType.Protocol:
        return ProtocolNode;
      case SurfaceNodeType.Document:
        return DocumentNode;
      case SurfaceNodeType.Text:
        return TextNode;
      case SurfaceNodeType.Image:
        return ImageNode;
      case SurfaceNodeType.Background:
        return BackgroundNode;
      case SurfaceNodeType.SubSurface:
        return SurfaceNode;
      case SurfaceNodeType.Questionnaire:
        return QuestionnaireNode;
      case SurfaceNodeType.DocumentSnippet:
        return DocumentSnippetNode;
      case SurfaceNodeType.TextSnippet:
        return TextSnippetNode;
      default:
        return () => null;
    }
  }, []);

  function NodeComponent(props) {
    const Node = getNodeComponent(props.node);

    return (
      <Node
        {...defaultNodeDimensions.general}
        node={props.node}
        deleteLink={deleteLink}
        {...props}
      />
    );
  }

  return React.useCallback(NodeComponent, []);
}
